import { Image, Modal, ModalBody, ModalCloseButton, ModalContent, ModalOverlay } from "@chakra-ui/react";


export default function ImageModal({
    isModalOpen,
    closeImageModal,
    modalImageSrc
}) {

return (
    <Modal isOpen={isModalOpen} onClose={closeImageModal} size="xl">
    <ModalOverlay />
    <ModalContent>
      <ModalCloseButton />
      <ModalBody>
        <Image src={modalImageSrc} alt="Large View" maxW="100%" maxH="80vh" />
      </ModalBody>
    </ModalContent>
  </Modal>
)
}